import { sleep } from '../../assets/js/utils.js';

const css = `
    .thalia-hinweis {
        z-index: 1;
    }
    
    /* STANDARD */
    .thalia-hinweis[data-status="standard"] {
        width: 100%;
        height: auto;
        opacity: 0;
        transition: opacity 0.4s ease;
    }
    
    .thalia-hinweis[data-status="standard"][open] {
        opacity: 1;
    }
    
    /* BLOCKING */
    .thalia-hinweis[data-status="blocking"] {
        width: 100%;
        height: auto;
        max-width: 400px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        opacity: 0;
        padding: 10px 10px 10px 40px;
        transition: opacity 0.4s ease;
    }
    
    .thalia-hinweis[data-status="blocking"][open] {
        opacity: 1;
    }
    
    
    /* NON-BLOCKING / TOASTR */
    .thalia-hinweis[data-status="toastr"] {
        width: 100%;
        max-width: 400px;
        position: fixed;
        bottom: 0;
        right: calc(-1 * 400px);
        transition: transform 0.15s ease-in;
        transform: translateX(0);
        box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    }
    
    .thalia-hinweis[data-status="toastr"][open] {
        transform: translateX(calc(-1 * 400px));
        transition-duration: 0.25s;
        transition-timing-function: cubic-bezier(0.34, 1.56, 0.64, 1);
    }
    
    @media screen and (min-width: 481px) {
        .thalia-hinweis[data-status="toastr"] {
            bottom: 40px;
        }
    
        .thalia-hinweis[data-status="toastr"][open] {
            transform: translateX(calc(-1 * 400px - 40px));
        }
    }`;

async function toggleHinweis(container, options) {
    const hinweis = hinweisErstellen(options);
    // Rendern
    container.insertAdjacentElement('beforeend', hinweis);
    await sleep(200);
    // [open] hinzufügen
    hinweis.setAttribute('open', '');
    // Wenn toastr, dann meldung wieder ausblenden und aus dem DOM entfernen
    if (options.mode === "toastr") {
        await sleep(options.duration);
        hinweis.removeAttribute('open');
        await sleep(200);
        hinweis.parentNode.removeChild(hinweis);
    }
}

function hinweisErstellen(options) {
    const style = document.createElement('style');
    style.innerHTML = css;
    const hinweis = document.createElement('span');
    hinweis.classList.add('element-notification-'+options.type);
    hinweis.classList.add('thalia-hinweis');
    hinweis.setAttribute('data-status', options.mode);
    if(options.type === "warning" || options.type === "urgent") {
        hinweis.setAttribute("role", "alert");
    } else {
        hinweis.setAttribute("role", "status");
    }
    const hinweisText = document.createElement('p');
    hinweisText.classList.add('element-text-standard');
    hinweisText.innerHTML = options.text;
    hinweis.appendChild(hinweisText);
    hinweis.insertAdjacentElement('afterbegin', style);
    return hinweis;
}

export { toggleHinweis };
